import React, { useRef, useState } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';
import './EnhancedComponents.css';

const Hello = () => {
  const galleryRef = useRef();
  const [showMore, setShowMore] = useState(false);

  const handleSouthington = () => {
    // Scroll to Apple section
    document.getElementById('apple')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="hello" className="section hello-section">
      <div className="section-header">
        <h1>Ciao</h1>
      </div>
      <div className="hello-content">
        <p className="welcome-text">Welcome to my site! I'm Marco De Marco, and I'm excited to have you here. This site is a celebration of family, heritage, and the things that matter most to me, that I would like to share with you.</p>

        {showMore && (
          <div className="extended-intro">
            <p>From my Italian roots with my tree spanning over 150 years, to my home in Southington, Connecticut, to the simple pleasures of good food, wine, and family traditions - this site tells my story.</p>
            <p>Whether you're here to explore my family history, learn about town, or discover some authentic Italian recipes, I hope you find something that connects with you.</p>
          </div>
        )}
      </div>

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-birthday-cake"></i>{showMore ? 'Less' : 'More About Me'}
        </button>

        <button className="cta-btn secondary" onClick={handleSouthington}>
          <i className="fas fa-heart"></i>I Love Southington
        </button>
      </div>
	  
	  <Gallery ref={galleryRef} images={galleryData.hello} sectionName=" " thumbnailSize={300} maxDisplay={4} />

    </section>
  );
};

export default Hello;
